import { isSparkJsFeatureUnlocked } from '../../../constants/sparkjs-features';
import type { CheckoutElement } from '../types/spark-options';

// Standard elements serialize with no type/translations. Older spark-js crashes reading them
export function isElementHiddenByVersionGate(
  element: CheckoutElement,
  sparkjsVersion: string | null | undefined,
): boolean {
  return (
    element.kind === 'standard' &&
    !isSparkJsFeatureUnlocked(sparkjsVersion, 'CHECKOUT_STANDARD_ELEMENTS')
  );
}

export function stripVersionGatedCheckoutElements(
  elements: CheckoutElement[],
  sparkjsVersion: string | null | undefined,
): CheckoutElement[] {
  return elements.filter((element) => !isElementHiddenByVersionGate(element, sparkjsVersion));
}
